import React from 'react'
import Button from '../Button/Button'
import Style from './OrdersModal.module.css'
const OrdersModal = ({setShow,data}) => {
    // console.log(data)
    return (
        <div className={Style.factorHolder}>
            <h1 className={Style.title}>لیست سفارشات</h1>
            <ul className={Style.factorList}>
                {
                data===undefined?<h3 style={{color:"#c20c64"}}>loading...</h3>:
                    data.map((item,index)=>{
                    return(
                        <li key={index} className={Style.ShoppingList} >
                            <p className={Style.WidthHolder}>{item.name}</p>
                            <span className={Style.count}>{item.count} عدد</span>
                            {/* <h3 className={Style.marketName}>{item.supplier_name} </h3> */}
                        </li>
                    ) 
                })}
            </ul>
            <div className={Style.btnHolder}>
                <Button ClassBtn={"confirmBtn"} Value={"تایید"} ClickHandler={setShow}/>
            </div>
        </div>
    )
}
export default OrdersModal
